class Testimonials {

	static instances = [];

	constructor( node, opts = {} ) {
		if ( ! node ) {
			return;
		}

		this.node = node;
		this.opts = {
			items      : '.testimonials__items',
			next       : '.testimonials__next',
			prev       : '.testimonials__prev',
			pagination : '.testimonials__pagination',
			autoplay: false,
			interval: 5000,
		};

		Object.keys( this.opts ).forEach( key => {
			if ( typeof opts[ key ] !== 'undefined' ) {
				this.opts[ key ] = opts[ key ];
			} else if ( typeof this.node.dataset[ key ] !== 'undefined' ) {
				this.opts[ key ] = this.node.dataset[ key ];
			}
		} );

		this.items = node.querySelector( this.opts.items );
		this.prev  = node.querySelector( this.opts.prev );
		this.next  = node.querySelector( this.opts.next );
		this.pagination  = node.querySelector( this.opts.pagination );
		console.log(this.items.length)
		if ( this.opts.autoplay ) {
			this.interval = setInterval( () => {
				if ( this.getCurrentScrollIndex() >= items.children.length - 1 ) {
					return this.setScrollIndex(0);
				}

				return this.scrollNext();
			}, parseInt( this.opts.interval, 10 ) );
		}

		if ( this.prev ) {
			this.prev.addEventListener( 'click', () => {
				this.scrollPrev();

				if ( this.interval ) {
					clearInterval( this.interval );
				}
			} );
		}

		if ( this.next ) {
			this.next.addEventListener( 'click', () => {
				this.scrollNext();

				if ( this.interval ) {
					clearInterval( this.interval );
				}
			} );
		}

		if ( this.pagination ) {
			this.pagination.addEventListener( 'click', (e) => {
				console.log(e.target);
				let clickedDot = e.target;
				const dotIndex = [...clickedDot.parentElement.children].indexOf(clickedDot);
				this.setScrollIndex(dotIndex);
			} );
		}

		this.items.addEventListener( 'scroll', this.setState.bind( this ) );
		this.setScrollIndex(0);
		this.setState();

		Testimonials.instances.push(this);
	}

	scrollPrev() {
		this.setScrollIndex( Math.round( Math.max( this.getCurrentScrollIndex() - 1, 0 ) ) );
	}

	scrollNext() {
		this.setScrollIndex( Math.round( Math.min( this.getCurrentScrollIndex() + 1, this.items.children.length - 1 ) ) );
	}

	setScrollIndex( index, behavior = 'smooth' ) {
		this.items.scrollTo( {
			left: index * this.items.offsetWidth,
			top: 0,
			behavior: behavior || this.opts.scrollBehavior
		} );
	};

	getCurrentScrollIndex() {
		return Math.round( this.items.scrollLeft / this.items.offsetWidth );
	}

	setState() {
		const index = this.getCurrentScrollIndex();

		if ( index >= this.items.children.length - 1 ) {
			if ( this.next ) {
				this.next.disabled = true;
			}

			if ( this.prev ) {
				this.prev.removeAttribute('disabled');
			}
		} else if ( index <= 0 ) {
			if ( this.next ) {
				this.next.removeAttribute('disabled');
			}

			if ( this.prev ) {
				this.prev.disabled = true;
			}
		} else {
			if ( this.next ) {
				this.next.removeAttribute('disabled');
			}

			if ( this.prev ) {
				this.prev.removeAttribute('disabled');
			}
		}

		let prevActiveDot = this.pagination.querySelector('[disabled]');
		if( prevActiveDot ) {
			prevActiveDot.removeAttribute('disabled');
		}
		this.pagination.children[index].disabled = true;
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.testimonials' ).forEach( node => {
		new Testimonials( node )
	} );
} );

export default Testimonials;
